import licenseModule from '../../license.module';

export default licenseModule.component('licenseNewServerSubscription', {
    template: require('./licenseNewServerSubscription.component.html'),
    controller: ['entitlementConstants', licenseNewServerSubscriptionComponent],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        licenseMaxDevices: '<',
        licenseMaxUsers: '<',
        callback: '&'
    }
});

function licenseNewServerSubscriptionComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    vm.$onInit = function() {
        vm.licenseMaxDevices = 0;
        vm.licenseMaxUsers = 0;
        vm.min = 1;
    };

    vm.changes = function() {
        var value = {
            license: {
                maxUsers: vm.licenseMaxUsers,
                maxDevices: vm.licenseMaxDevices
            }
        };
        vm.callback({ value: value });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-new-server-subscription/licenseNewServerSubscription.component.js